<!-- <ngx-loading [show]="loading"></ngx-loading> -->
<mat-toolbar [color]="'accent'">
  <button (click)="returnToMenu()" mat-icon-button>
    <mat-icon>arrow_back</mat-icon>
  </button>
  @if (!loading && meeting) {
    <span>{{ meeting.description }}</span>
  }

  <span class="spacer"></span>
</mat-toolbar>

@if (meeting) {
  <div class="scroll-container">
    <div class="main-background">
      <div class="flex-container">
        @if (!loading && config.config.urmServices.enabled) {
          <urm-property-info
          [externalPropertyReference]="meeting.externalPropertyReference"></urm-property-info>
        }
        <div class="property-info">
          <div class="property-row">Property Id: {{ meeting.externalPropertyReference }}</div>
          @if (meeting.location) {
            <div class="property-row">
              GPS: {{ meeting.location.latitude.toPrecision(5) }}, {{ meeting.location.longitude.toPrecision(5) }}
            </div>
          }
        </div>
        @if (meeting && meeting.visitList) {
          <div class="visit-list-container">
            <app-grid #visitGrid (gridEvents)="processGridEvent($event)" [autoHeight]="true" [cellEdit]="false"
              [columns]="visitColumns" [filter]="true" [readOnly]="true" [rowExpander]="rowExpanderConfig" [rowHeight]="50"
            [width]="'100%'" ngClass="visit-grid"></app-grid>
          </div>
        }
        <!--      <button (click)="addVisit()" *ngIf="!loading && !job.externalProjectReference && job.status !== JobStatus.CLOSED "-->
        <!--              class="primary-fab-button"-->
        <!--              color="warn"-->
        <!--              mat-fab>-->
        <!--        <mat-icon class="icon-class" fontIcon="fa-plus" fontSet="fas"></mat-icon>-->
      <!--      </button>-->
    </div>
  </div>
</div>
}